import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Eye, EyeSlash } from 'react-bootstrap-icons'
import axiosService from '../../utils/AxiosService'
import Input from '../FormComponents/Input'
import { toastError, toastSuccess } from '../FormComponents/Toasts'

export default function AdvertiserSharedClientPassword() {
  const { token } = useParams()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const authenticate = (e) => {
    e.preventDefault()
    if (!password.trim()) return

    setIsLoading(true)
    axiosService.post('/api/advertiser/client_share/sessions', { token, password })
      .then(shareLink => {
        toastSuccess('Correct password')
        navigate(`/advertiser/client_share/${shareLink.id}`)
      })
      .catch(({ data: { error } }) => toastError(error))
      .finally(() => setIsLoading(false))
  }

  return (
    <div className="w-screen h-screen text-center flex flex-col justify-center items-center">
      <p className="mb-4 text-gray-600">Please type the password which was shared with you here to unlock the link</p>
      <form onSubmit={authenticate} className="w-80">
        <Input
          topMargin="mt-0"
          placeholder="Password"
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={e => setPassword(e.target.value)}
          addon={showPassword ? <EyeSlash className="cursor-pointer" /> : <Eye className="cursor-pointer" />}
          addonPosition="end"
          onAddonClick={() => setShowPassword(prev => !prev)}
          autoFocus
        />
        <button
          type="submit"
          disabled={isLoading || !password.trim()}
          className="bg-rb-green text-white px-4 py-2 rounded-2xl w-full mt-4 disabled:opacity-50"
        >
          {isLoading ? 'Checking...' : 'Submit'}
        </button>
      </form>
    </div>
  )
}
